import { useCallback, useState } from 'react'
import {
  sortSessions,
  Session,
  Sessions
} from '@builder/alphas/schedule/alpha-schedule.utils'

function useSessions(initialSessions: Sessions | null) {
  const [sessions, setSessions] = useState<Sessions | null>(initialSessions)

  const setTrainingSessions = useCallback((trainingList: Session[]) => {
    setSessions((prev) => ({
      ...prev,
      training: trainingList
    }))
  }, [])

  const setCourseSessions = useCallback((courseList: Session[]) => {
    setSessions((prev) => ({
      ...prev,
      course: courseList
    }))
  }, [])

  const setAllSessions = useCallback((fullSessions: Sessions) => {
    setSessions({
      totalWeekendSessions: fullSessions.totalWeekendSessions,
      training: sortSessions(fullSessions.training),
      course: sortSessions(fullSessions.course)
    })
  }, [])

  return {
    sessions,
    setAllSessions,
    setTrainingSessions,
    setCourseSessions
  }
}

export default useSessions
